module.exports = __webpack_public_path__ + "static/media/uis_logo.205d5749.svg";